import { GRAY_1, GRAY_2 } from './mc-tokens';

export const MODUS_ICON_BUTTON_STYLESHEET = `
.mc-icon-btn:hover {
  background-color: ${GRAY_1} !important;
}
.mc-icon-btn.modus-wc-btn-circle:hover {
  border-radius: 50%;
}
.mc-icon-btn.modus-wc-btn-active {
  background-color: ${GRAY_2} !important;
}
`;
